import { Box, Avatar, Typography, Stack } from "@mui/material";
// config
import colors from "../../../config/colors";

const Profile = ({ item }) => {
  const gender =
    item?.gender === "M" ? "Male" : item?.gender === "F" ? "Female" : "Unisex";
  const categories =
    item?.product_categories
      ?.slice() // Create a copy of the array first
      ?.sort((a, b) => b.percentage - a.percentage) // Sort by percentage descending
      ?.slice(0, 1) // Take top 2 categories
      ?.map((item) => item?.category) || [];
  const tags = [gender, ...categories];
  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
      <Avatar sx={{ width: 48, height: 48 }} src={item?.avatar} />
      <Box sx={{ minWidth: 0, flex: 1 }}>
        <Typography
          fontSize={12}
          fontWeight={500}
          mb={0.5}
          noWrap
          lineHeight="20px"
        >
          @{item?.username}
        </Typography>
        <Stack flexWrap="nowrap" flexDirection="row" gap={1} overflow="auto">
          {tags?.map((tag) => (
            <Box
              sx={{
                backgroundColor: colors.primary100,
                padding: "2px 8px",
                borderRadius: "4px",
                textAlign: "center",
                minWidth: "fit-content",
                display: "inline-block",
              }}
            >
              <Typography fontSize={10} fontWeight={400} lineHeight="16px">
                {tag}
              </Typography>
            </Box>
          ))}
        </Stack>
      </Box>
    </Box>
  );
};

export default Profile;
